import EmptyResults from 'components/EmptyResults'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Grid, Icon, List, Spinner } from 'gu-ui-kit'
import { ReactComponent as EmptyResultsSVG } from 'images/illustration/no-referrals.svg'

import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useTableConfig } from 'modules/Advertisers/List/subcomponents/Table/hooks/useTableConfig'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import { SET_STATUS } from 'modules/Advertisers/List/types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const Table = ({ data = [], pagination, loading, onChangePage }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const pathGen = useGeneratePathI18n()
  const breakpoint = useBreakpoint()

  const changeStatus = useCallback(
    (id, status) => dispatch({ type: SET_STATUS, payload: { id, status } }),
    [],
  )

  const { tableState, tableConfig } = useTableConfig({ changeStatus }, data)

  return data.length === 0 && loading ? (
    <GridSpinner />
  ) : (
    <>
      <List
        table={tableState}
        config={tableConfig}
        EmptyComponent={() => (
          <EmptyResults
            header={t('advertisers::empty_list_heading')}
            text={t('advertisers::empty_list')}
            image={<EmptyResultsSVG />}
            actionButton={
              <Button
                variant={'primary'}
                size={'l'}
                component={Link}
                fullWidth={!breakpoint.fb}
                to={pathGen(ROUTES.ADVERTISER_NEW)}
                startIcon={<Icon name={'plus'} />}
              >
                {t('advertisers::buttons.add')}
              </Button>
            }
          />
        )}
      />
      {data.length > 0 && pagination.total !== data.length && (
        <div>
          <Grid
            alignItems={'center'}
            justifyContent={'center'}
          >
            {pagination.total !== data.length && (
              <Button
                onClick={() => onChangePage(1)}
                variant={'link'}
                color={'Label-GU-Primary'}
                startIcon={
                  loading ? (
                    <Spinner
                      width={16}
                      color={'inherit'}
                    />
                  ) : null
                }
                endIcon={
                  <Icon
                    name={'arrow-down'}
                    color={'inherit'}
                    size={'s'}
                  />
                }
              >
                {t('common::pagination.show_more')}
              </Button>
            )}
          </Grid>
        </div>
      )}
    </>
  )
}

Table.propTypes = {
  data: PropTypes.array,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  onChangePage: PropTypes.func,
  i18n: PropTypes.string,
}

export default Table
